// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"TZ-z","sponsoredTooltipWrapper":"UZ-z","sponsoredTooltip":"VZ-z","newCard":"WZ-z"};